var map = {
	"./pr-1.png": "005c",
	"./pr-2.png": "6138",
	"./pr-3.png": "ed2a",
	"./pr-4.png": "57f4",
	"./pr-5.png": "12a6",
	"./pr-5_.png": "2c39",
	"./pr-6.png": "eefe",
	"./pr-7.png": "23e2",
	"./pr-8.png": "bdbb",
	"./pr-9.png": "e667e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8474";